<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <card class="shadow-lg px-3">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard
          ref="formWizard"
          v-if="this.isCreate() || this.isUpdate()"
          @on-complete="storeUpdateStation"
          title
          subtitle
          :back-button-text="$t('common_words.back')"
          :next-button-text="$t('common_words.next')"
          :finish-button-text="$t('common_words.save')"
          class="custom-padding-wz-header"
        >
          <tab-content
            :title="$t('common_words.general_information')"
            :before-change="() => validateStep('firstStep')"
          >
            <first-step
              ref="firstStep"
              @on-validated="onStepValidated"
              @fillStationForm="fillStationForm"
              @showHideLoading="showHideLoading"
            ></first-step>
          </tab-content>
          <tab-content
            :title="$t('common_words.ubication')"
            :before-change="() => validateStep('secondStep')"
          >
            <second-step
              ref="secondStep"
              @on-validated="onStepValidated"
              @fillStationForm="fillStationForm"
              @showHideLoading="showHideLoading"
            ></second-step>
          </tab-content>
          <tab-content
            :title="$t('common_words.association')"
            :before-change="() => validateStep('thirdStep')"
          >
            <third-step
              ref="thirdStep"
              @on-validated="onStepValidated"
              @fillStationForm="fillStationForm"
              @showHideLoading="showHideLoading"
            ></third-step>
          </tab-content>
          <tab-content
            :title="$t('devices.nearby_stations')"
            :before-change="() => validateStep('fourthStep')"
          >
            <fourth-step
              ref="fourthStep"
              @on-validated="onStepValidated"
              @fillStationForm="fillStationForm"
              @showHideLoading="showHideLoading"
            ></fourth-step>
          </tab-content>
          <tab-content :title="$t('common_words.confirm')">
            <p class="cm-mg-p-wzd text-center text-muted">
              4.1 {{ $t('common_words.verify_inputed_information') }}
            </p>
            <br />
            <div class="row d-flex justify-content-center">
              <div class="col-10">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.name') }}:</strong>
                        </h6>
                        {{ stationForm.name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.alias') }}:</strong>
                        </h6>
                        {{ stationForm.name2 }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.type') }}:</strong>
                        </h6>
                        {{ stationForm.station_type }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('devices.brand') }}:</strong>
                        </h6>
                        {{ stationForm.station_mark }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.code_serial') }}:</strong>
                        </h6>
                        {{ stationForm.code_station }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.order') }}:</strong>
                        </h6>
                        {{ stationForm.order }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.api_request') }}:</strong>
                        </h6>
                        {{
                          stationForm.is_request === 0
                            ? $t('common_words.mayus_no')
                            : $t('common_words.mayus_yes')
                        }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{
                              $t('common_words.associated_companies')
                            }}:</strong
                          >
                        </h6>
                        <span
                          v-for="(
                            business, index
                          ) in stationForm.names_business"
                          :key="index"
                        >
                          <el-tag type="info">{{ business }}</el-tag>
                        </span>
                        <el-tag
                          type="warning"
                          v-if="stationForm.names_business.length == 0"
                          >{{
                            $t('common_words.no_associated_companies')
                          }}</el-tag
                        >
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong>{{
                            $t('common_words.associated_farms')
                          }}</strong>
                        </h6>
                        <span
                          v-for="(farm, index) in stationForm.names_farms"
                          :key="index"
                        >
                          <el-tag type="info">{{ farm }}</el-tag>
                        </span>
                        <el-tag
                          type="warning"
                          v-if="stationForm.names_farms.length == 0"
                          >{{ $t('common_words.no_associated_farms') }}</el-tag
                        >
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{ $t('devices.associated_sensors') }}:</strong
                          >
                        </h6>
                        <span
                          v-for="(sensor, index) in stationForm.namesSensors"
                          :key="index"
                        >
                          <el-tag type="info">{{ sensor }}</el-tag>
                        </span>
                        <el-tag
                          type="warning"
                          v-if="stationForm.namesSensors.length == 0"
                          >{{ $t('devices.no_associated_sensors') }}</el-tag
                        >
                        <h6 class="my-2 custom-margin-h6-table">
                          <strong
                            >{{
                              $t('devices.associated_calculations')
                            }}:</strong
                          >
                        </h6>
                        <span
                          v-for="(
                            sensor, index
                          ) in stationForm.namesCalculatedSensors"
                          :key="`${index}-${sensor}`"
                        >
                          <el-tag type="info">{{ sensor }}</el-tag>
                        </span>
                        <el-tag
                          type="warning"
                          v-if="stationForm.namesCalculatedSensors.length == 0"
                          >{{
                            $t('devices.no_associated_calculations')
                          }}</el-tag
                        >
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong>{{ $t('devices.nearby_stations') }}:</strong>
                        </h6>
                        <div class="row">
                          <div class="col-4">
                            <p>{{ $t('devices.station') }}:</p>
                          </div>
                          <div class="col-4">
                            <p>{{ $t('devices.sensors') }}:</p>
                          </div>
                          <div class="col-4">
                            <p>
                              {{ $t('devices.associated_calculated_sensors') }}:
                            </p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-4">
                            <el-tag
                              type="info"
                              v-if="stationForm.station_access"
                              >{{ stationForm.station_access }}</el-tag
                            >
                            <el-tag type="warning" v-else>{{
                              $t('devices.no_associated_stations')
                            }}</el-tag>
                          </div>
                          <div class="col-4">
                            <template
                              v-if="
                                stationForm.sensors_access &&
                                stationForm.sensors_access.length > 0
                              "
                            >
                              <el-tag
                                type="info"
                                v-for="(
                                  sensorAccess, key
                                ) in stationForm.sensors_access"
                                :key="`${sensorAccess}-${key}`"
                                >{{ sensorAccess.name }}</el-tag
                              >
                            </template>
                            <el-tag type="warning" v-else>{{
                              $t('devices.does_not_have_sensors_provided')
                            }}</el-tag>
                          </div>
                          <div class="col-4">
                            <template
                              v-if="
                                stationForm.calculated_sensors_access &&
                                stationForm.calculated_sensors_access.length > 0
                              "
                            >
                              <el-tag
                                type="info"
                                v-for="(
                                  sensor, key
                                ) in stationForm.calculated_sensors_access"
                                :key="`${sensor}-${key}`"
                                >{{ `${sensor.name}` }}</el-tag
                              >
                            </template>
                            <el-tag type="warning" v-else>{{
                              $t('devices.no_associated_calculations')
                            }}</el-tag>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-10">
                <div
                  ref="map"
                  class="map"
                  v-if="renderComponent"
                  style="height: 500px"
                ></div>
              </div>
            </div>
          </tab-content>
        </form-wizard>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_operations') }}
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { showContinue } from 'src/util/Util.js';
import FirstStep from './steps/FirstStep.vue';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SecondStep from './steps/SecondStep.vue';
import ThirdStep from './steps/ThirdStep.vue';
import FourthStep from './steps/FourthStep.vue';

export default {
  components: {
    FirstStep,
    SecondStep,
    ThirdStep,
    FourthStep,
  },

  data() {
    return {
      center: {
        lat: 10.8906,
        lng: -74.18756,
        alt: 24,
      },
      title: '',
      stationForm: {
        names_business: [],
        names_farms: [],
        namesSensors: [],
        namesCalculatedSensors: [],
        station_type: null,
        station_mark: null,
      },
      wizardModel: {},
      map: null,
      renderComponent: true,
    };
  },

  mixins: [MixinPermissions, MixinArcgisMap, mixinMasters, MixinMenu],

  methods: {
    cleanAllSteps() {
      this.$refs.firstStep.model = {};
      this.$refs.secondStep.model = {};
      this.$refs.thirdStep.model = {};
      this.$refs.fourthStep.model = {};
      this.stationForm = {
        names_business: [],
        names_farms: [],
        namesSensors: [],
        namesCalculatedSensors: [],
      };
    },

    validateStep(ref) {
      return this.$refs[ref].validate();
    },

    onStepValidated(_, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },

    fillStationForm(ref, others) {
      this.stationForm = Object.assign(
        {},
        this.stationForm,
        this.$refs[ref].model
      );

      if (others)
        this.stationForm = Object.assign({}, this.stationForm, others);

      this.center.lat = this.stationForm.latitude
        ? parseFloat(this.stationForm.latitude)
        : this.center.lat;
      this.center.lng = this.stationForm.longitude
        ? parseFloat(this.stationForm.longitude)
        : this.center.lng;
      this.center.alt = this.stationForm.altitude
        ? parseFloat(this.stationForm.altitude)
        : this.center.alt;

      this.loadMap();
    },

    storeUpdateStation() {
      this.showHideLoading(true);
      this.stationForm.route = 'devices/stations';
      if (sessionStorage.getItem('editForm')) {
        if (this.isUpdate()) {
          this.stationForm.id = JSON.parse(
            sessionStorage.getItem('editForm')
          ).id;
          Axios.updateMaster(this.stationForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/devices/stations',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.stationForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/devices/stations',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },

    loadMap() {
      this.renderComponent = false;

      this.$nextTick(() => {
        this.renderComponent = true;
        this.loadBaseMap(null);
      });
    },
  },

  mounted() {
    this.selectedItemOnMenu('devices');
  },

  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    this.deselectedItemOnMenu('devices');
  },
};
</script>
<style></style>
